import { render, staticRenderFns } from "./PendingDecisions.vue?vue&type=template&id=0c9ce182&scoped=true"
import script from "./PendingDecisions.vue?vue&type=script&lang=js"
export * from "./PendingDecisions.vue?vue&type=script&lang=js"
import style0 from "./PendingDecisions.vue?vue&type=style&index=0&id=0c9ce182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ce182",
  null
  
)

export default component.exports